var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdjustments = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6 3.15c.47 0 .85.38.85.85v9.279a2.851 2.851 0 0 1 0 5.442V20a.85.85 0 0 1-1.7 0v-1.279a2.851 2.851 0 0 1 0-5.442V4c0-.47.38-.85.85-.85m6 0c.47 0 .85.38.85.85v1.279a2.851 2.851 0 0 1 0 5.442V20a.85.85 0 0 1-1.7 0v-9.279a2.851 2.851 0 0 1 0-5.442V4c0-.47.38-.85.85-.85m6 0c.47 0 .85.38.85.85v9.279a2.851 2.851 0 0 1 0 5.442V20a.85.85 0 0 1-1.7 0v-1.279a2.851 2.851 0 0 1 0-5.442V4c0-.47.38-.85.85-.85m-6 3.7a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3m-6 8a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3m12 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 0 0 0-2.3",
  clipRule: "evenodd"
})));
export default SvgAdjustments;